<template>
  <div>
    <NavBar pageName="Termeni si Conditii" />
    <v-container style="margin-top: 185px;">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span>
            <v-icon class="mr-2">mdi-file-document-outline</v-icon>
            Termeni si Conditii Generale
          </span>
          <div class="d-flex ga-2">
            <v-btn
              color="info"
              variant="outlined"
              size="small"
              href="/TermsAndConditions.pdf"
              target="_blank"
            >
              <v-icon class="mr-1">mdi-file-pdf-box</v-icon>
              Descarca PDF
            </v-btn>
            <v-btn
              v-if="isAdmin && !editMode"
              color="primary"
              size="small"
              @click="editMode = true"
            >
              <v-icon class="mr-1">mdi-pencil</v-icon>
              Editeaza
            </v-btn>
            <v-btn
              v-if="editMode"
              color="grey"
              variant="outlined"
              size="small"
              @click="cancelEdit"
            >
              Anuleaza
            </v-btn>
            <v-btn
              v-if="editMode"
              color="success"
              size="small"
              @click="saveDocument"
              :loading="saving"
            >
              <v-icon class="mr-1">mdi-content-save</v-icon>
              Salveaza & Genereaza PDF
            </v-btn>
          </div>
        </v-card-title>

        <v-card-text>
          <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-4" />

          <v-alert v-if="lastModified" type="info" variant="tonal" density="compact" class="mb-4">
            Ultima modificare: {{ lastModified }}
            <span v-if="pdfLastModified"> | PDF generat: {{ pdfLastModified }}</span>
          </v-alert>

          <!-- Edit Mode -->
          <template v-if="editMode">
            <v-tabs v-model="activeTab" class="mb-4">
              <v-tab value="editor">Editor HTML</v-tab>
              <v-tab value="preview">Preview</v-tab>
            </v-tabs>

            <v-window v-model="activeTab">
              <v-window-item value="editor">
                <v-textarea
                  v-model="editContent"
                  rows="25"
                  variant="outlined"
                  density="compact"
                  style="font-family: monospace; font-size: 13px;"
                  hide-details
                />
              </v-window-item>
              <v-window-item value="preview">
                <div class="terms-content pa-4 border rounded" v-html="editContent"></div>
              </v-window-item>
            </v-window>
          </template>

          <!-- View Mode -->
          <template v-else-if="htmlContent && !loading">
            <div class="terms-content" v-html="htmlContent"></div>
          </template>

          <template v-else-if="!loading">
            <v-alert type="warning" density="compact">
              Documentul nu a fost gasit.
            </v-alert>
          </template>
        </v-card-text>
      </v-card>

      <!-- Snackbar -->
      <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="3000">
        {{ snackbar.message }}
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import { getLegalDocument, updateLegalDocument } from '@/composables/useLegalDocumentsAPI'
import store from '@/store'

export default {
  name: 'LegalTermsView',
  components: { NavBar },
  data() {
    return {
      loading: false,
      saving: false,
      htmlContent: '',
      editContent: '',
      editMode: false,
      activeTab: 'editor',
      lastModified: null,
      pdfLastModified: null,
      snackbar: { show: false, message: '', color: 'success' }
    }
  },
  computed: {
    token() {
      return store.getters.getToken
    },
    isAdmin() {
      const user = store.getters.getUser
      if (!user) return false
      const role = (user.role_name || user.role || '').toLowerCase()
      return ['root', 'admin'].includes(role)
    }
  },
  async mounted() {
    await this.loadDocument()
  },
  methods: {
    async loadDocument() {
      this.loading = true
      try {
        const result = await getLegalDocument(this.token)
        if (!result.error) {
          this.htmlContent = result.html_content || ''
          this.lastModified = result.last_modified ? new Date(result.last_modified).toLocaleString() : null
          this.pdfLastModified = result.pdf_last_modified ? new Date(result.pdf_last_modified).toLocaleString() : null
        } else {
          this.showSnackbar(result.message, 'error')
        }
      } finally {
        this.loading = false
      }
    },
    cancelEdit() {
      this.editMode = false
      this.editContent = ''
      this.activeTab = 'editor'
    },
    async saveDocument() {
      this.saving = true
      try {
        const result = await updateLegalDocument(this.token, this.editContent)
        if (!result.error) {
          this.showSnackbar(result.message, 'success')
          this.editMode = false
          this.activeTab = 'editor'
          await this.loadDocument()
        } else {
          this.showSnackbar(result.message, 'error')
        }
      } finally {
        this.saving = false
      }
    },
    showSnackbar(message, color = 'success') {
      this.snackbar = { show: true, message, color }
    }
  },
  watch: {
    editMode(val) {
      if (val) {
        this.editContent = this.htmlContent
      }
    }
  }
}
</script>

<style scoped>
.terms-content {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
